import { LoaderCircle } from 'lucide-react';
import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAutoReload } from '../hooks/use-auto-reload';
import { cn } from '../utils/class-names.util';

import { CommonButton } from './common-button';

interface Props {
  fitContent?: boolean;
  hideText?: boolean;
  autoReload?: boolean;
}

export const CommonRecoveryFallback: FC<Props> = memo(
  ({ fitContent, hideText, autoReload = true }) => {
    const { t } = useTranslation('common');
    const countdown = useAutoReload({ enabled: autoReload });

    const containerClass = useMemo(() => {
      return cn(
        'bg-background relative flex min-h-screen w-full items-center justify-center',
        fitContent && 'min-h-0 w-auto'
      );
    }, [fitContent]);

    const handleReload = (): void => {
      window.location.reload();
    };

    return (
      <div className={containerClass}>
        <div className="mx-auto flex max-w-sm flex-col items-center justify-center gap-4">
          <LoaderCircle className="text-foreground-soft h-12 w-12 animate-spin" />
          {!hideText && (
            <div className="flex flex-col items-center gap-2">
              <p className="text-foreground-soft text-center text-base font-medium">{t('recovering')}</p>
              <p className="text-foreground-muted text-center text-sm">
                {autoReload
                  ? t('autoReloadMessage', { seconds: countdown, count: countdown })
                  : t('recoveringDescription')}
              </p>
              {!autoReload && <CommonButton onClick={handleReload}>{t('reload')}</CommonButton>}
            </div>
          )}
        </div>
      </div>
    );
  },
  () => true
);
CommonRecoveryFallback.displayName = 'CommonRecoveryFallback';
